import { render, staticRenderFns } from "./store-component.vue?vue&type=template&id=f205a868&scoped=true&"
import script from "./store-component.vue?vue&type=script&lang=ts&"
export * from "./store-component.vue?vue&type=script&lang=ts&"
import style0 from "./store-component.vue?vue&type=style&index=0&id=f205a868&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f205a868",
  null
  
)

export default component.exports